const LogoTypes = {
  SHIELD: "shield",
  WHITE: "white",
  BLACK: "black"
};

export default LogoTypes;
